import React, { useState } from 'react'
import Header from '../header/header'
import Footer from '../footer/footer'
import { useEffect } from 'react'
import { getTermsAndCondition } from '../services';
import Skeleton from "../auth/component/skeleton";
import DOMPurify from "dompurify";

const About = () => {
  const [aboutUs, setAboutus] = useState({})
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAboutUs()
  }, [])


  const getAboutUs = async () => {
    try {
      const res = await getTermsAndCondition('about_us')
      console.log(res.data[0])
      await setAboutus(res?.data[0])
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    < >

      <Header />
      <div className='grid grid-cols-1 bg-white container py-5 mx-auto'>
        {loading ?
          (
            <>
              <div className="flex flex-col items-center bg-white shadow-md rounded-lg p-4">
                <Skeleton width='100%' />

              </div>
            </>
          ) :
          (
            <>
              <div
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(aboutUs?.content) }}
                className="html-container"
              />
            </>
          )
        }
      </div>
      {/* <Footer /> */}
      <Footer />

    </>
  )
}

export default About